import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';

import PageHeading from 'components/PageHeading';
import TableSortCell from 'components/TableSortCell';
import TableActionCell from 'components/TableActionCell';
import TableCount from 'components/TableCount';
import PageHeadingButton from 'components/PageHeadingButton';

const getCardStatus = (item) => {
  const deactivationDate = new Date(item.deactivationDate);
  return Date.now() > deactivationDate.getTime() ? 'Expired' : 'Active';
};

class StampCardsListPage extends React.PureComponent {
  handleSort = (sortName, sortDirection) => {
    return this.props.onSort({ sortName, sortDirection });
  };

  handlePage = (event, page) => {
    return this.props.onPage({ page });
  };

  render() {
    const { items, totalResults } = this.props.initialData;
    const { sortName, sortDirection, pageLimit, page } = this.props;
    return (
      <Fragment>
        <PageHeading
          title="Stamp cards"
          right={
            <PageHeadingButton link="/stampcards-details">
              + New stamp card
            </PageHeadingButton>
          }
        />
        <TableCount count={totalResults} text="items in current selection" />
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableSortCell
                  title="Name"
                  sortName="name"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableSortCell
                  title="Stamps"
                  sortName="amountForFreeMenuItem"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableSortCell
                  title="Status"
                  sortName="deactivationDate"
                  currentSortName={sortName}
                  currentSortDirection={sortDirection}
                  handleSort={this.handleSort}
                />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.amountForFreeMenuItem}</TableCell>
                  <TableCell>{getCardStatus(item)}</TableCell>
                  <TableActionCell
                    link={`/stampcards-details/${item.id}`}
                    icon="edit"
                  />
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[pageLimit]}
            component="div"
            count={totalResults}
            rowsPerPage={pageLimit}
            page={page}
            onChangePage={this.handlePage}
          />
        </Paper>
      </Fragment>
    );
  }
}

StampCardsListPage.propTypes = {
  initialData: PropTypes.shape({
    items: PropTypes.array,
    totalResults: PropTypes.number,
  }).isRequired,
  sortName: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  pageLimit: PropTypes.number.isRequired,
  onSort: PropTypes.func.isRequired,
  onPage: PropTypes.func.isRequired,
};

export default StampCardsListPage;
